/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';

import { Card, Modal } from 'antd';
import { Collapse, Form, Flex, Row, Col, Space } from 'antd';
import { Input, Button, Table, message, DatePicker, Typography } from 'antd';
import { SearchOutlined, ClearOutlined, FileAddOutlined, PrinterOutlined } from '@ant-design/icons';
import { accessColumn, accessDetailColumn } from "./model";
import useAccessPageState from '../../../hooks/useAccessPageState';

import dayjs from 'dayjs';
import GoodsReceiptService from '../../../service/ERP/GoodsReceipt.service';


const quotService = GoodsReceiptService(); 
const mngConfig = {title:"", textOk:null, textCancel:null, action:"create", code:null};

const RangePicker = DatePicker.RangePicker;
const GoodsReceiptAccess = () => {
    const navigate = useNavigate();
    
    const [form] = Form.useForm();

    const [accessData, setAccessData] = useState([]);
    const [activeSearch, setActiveSearch] = useState([]);
    const {
        tablePagination,
        saveState,
        restoreState,
        clearState,
        restoreDefaultPagination,
        handleTableChange,
    } = useAccessPageState({ form });
     
    const CollapseItemSearch = (
        <>  
        <Row gutter={[8,8]}> 
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='รหัสใบรับสินค้า' name='grcode'>
                    <Input placeholder='Enter GoodsReceipt Code.' />
                </Form.Item>                            
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='วันที่ใบรับสินค้า' name='grdate'>
                    <RangePicker placeholder={['เริ่มวันที่', 'ถึงวันที่']} style={{width:'100%', height:40}}  />
                </Form.Item>
            </Col> 
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='รหัสผู้ขาย' name='supcode'>
                    <Input placeholder='Enter Supplier Code.' />
                </Form.Item>                            
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='ชื่อผู้ขาย' name='supname'>
                    <Input placeholder='Enter Supplier Name.' />
                </Form.Item>                            
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='เลขที่ Inv/ใบส่งของ' name='inv_no'>
                    <Input placeholder='Enter Invoice No.' />
                </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='รหัสสินค้า' name='stcode'>
                    <Input placeholder='Enter Item Code.' />
                </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='เลขที่ Lot' name='lot_no'>
                    <Input placeholder='Enter Lot No.' />
                </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Form.Item label='Express Lot' name='express_lot'>
                    <Input placeholder='Enter Express Lot.' />
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={[8,8]}>
          <Col xs={24} sm={8} md={12} lg={12} xl={12}>
              {/* Ignore */}
          </Col>
          <Col xs={24} sm={8} md={12} lg={12} xl={12}>
              <Flex justify='flex-end' gap={8}>
                  <Button type="primary" size='small' className='bn-action' icon={<SearchOutlined />} onClick={() => handleSearch()}>
                      Search
                  </Button>
                  <Button type="primary" size='small' className='bn-action' danger icon={<ClearOutlined />} onClick={() => handleClear()}>
                      Clear
                  </Button>
              </Flex>
          </Col>
        </Row> 
        </>
    )

    const FormSearch = (
        <Collapse 
        size="small"                    
        onChange={(e) => { setActiveSearch(e) }}
        activeKey={activeSearch} 
        items={[
        { 
            key: '1', 
            label: <><SearchOutlined /><span> Search</span></>,  
            children: <>{CollapseItemSearch}</>,
            showArrow: false, 
        } 
        ]}
        // bordered={false}
        />         
    );

    const handleSearch = (load = false, forcedValues = null, paginationOverride = null) => {
        const runSearch = (v) => {
            saveState(v, paginationOverride ?? tablePagination);
            const data = { ...v };
            if( !!data?.grdate ) {
                const arr = data?.grdate.map( m => dayjs(m).format("YYYY-MM-DD") )
                const [grdate_form, grdate_to] = arr; 
                //data.created_date = arr
                Object.assign(data, {grdate_form, grdate_to});
            }
            setTimeout( () => 
                quotService.search(data, { ignoreLoading: Object.keys(data).length !== 0}).then( res => {
                    const {data} = res.data;
        
                    setAccessData(data);
                }).catch( err => {
                    console.log(err);
                    message.error("Request error!");
                })
                , 80);
        };

        if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
            runSearch(forcedValues);
            return;
        }

        form.validateFields().then((v) => {
            runSearch(v);
        });
    }

    const handleClear = () => {
        clearState();
        form.resetFields();

        const nextPagination = restoreDefaultPagination();

        handleSearch(false, {}, nextPagination)
    }
    // console.log(form);
    const hangleAdd = () => {  
        navigate("manage/create", { state: { config: {...mngConfig, title:"สร้างใบรับสินค้า", action:"create"} } }); 
    }

    const handleEdit = (data) => {

        navigate("manage/edit", { state: { config: {...mngConfig, title:"แก้ไขใบรับสินค้า", action:"edit", code:data?.grcode} } } );
    };

    /* กดเลขที่ใบรับสินค้า -> หน้าแสดงข้อมูล (อ่านอย่างเดียว)
       ไม่ใช้ replace เพื่อให้กด "ย้อนกลับ" ของเบราว์เซอร์กลับมาหน้ารายการนี้ได้ */
    const handleView = (data) => {
        navigate("view", { state: { config: {...mngConfig, title:"ใบรับสินค้า", action:"view", code:data?.grcode} } });
    };

    const handleDelete = (data) => { 
        // startLoading();
        quotService.deleted(data?.quotcode).then( _ => {
            const tmp = accessData.filter( d => d.quotcode !== data?.quotcode );

            setAccessData([...tmp]); 
        })
        .catch(err => {
            console.log(err);
            message.error("Request error!");
        });
    }; 

    const handlePrint = (recode) => {
        const newWindow = window.open('', '_blank');
        newWindow.location.href = `/quo-print/${recode.grcode}`;
      };

    /* Print รายวัน : เลือก 1 วัน แล้วพิมพ์บันทึกตรวจรับวัตถุดิบ (QC)
       ของใบรับสินค้าทุกใบที่วันที่ใบรับสินค้าตรงกับวันนั้น */
    const handlePrintDaily = () => {
        let picked = dayjs();

        Modal.confirm({
            title: 'Print รายวัน — บันทึกตรวจรับวัตถุดิบ (QC)',
            icon: null,
            width: 420,
            content: (
                <div style={{ marginTop: 8 }}>
                    <div style={{ marginBottom: 6 }}>เลือกวันที่ใบรับสินค้า</div>
                    <DatePicker
                        defaultValue={picked}
                        format='DD/MM/YYYY'
                        allowClear={false}
                        style={{ width: '100%', height: 40 }}
                        onChange={(d) => { picked = d; }}
                    />
                </div>
            ),
            okText: 'Print',
            cancelText: 'ปิด',
            onOk: () => {
                if (!picked) {
                    message.warning('กรุณาเลือกวันที่');
                    return Promise.reject();
                }
                const d = dayjs(picked).format('YYYY-MM-DD');
                window.open(`/gr-qc-print-daily/${d}`, '_blank');
            },
        });
    };

    const handleQc = (record) => {
        navigate("qc", { state: { config: { title: "บันทึกตรวจรับวัตถุดิบ", action: "qc", code: record?.grcode } } });
    };


    const handleTags = (record) => {
        navigate("tags", { state: { config: { title: "แยก Tags", action: "tags", code: record?.grcode } } });
    };

    const column = accessColumn( {handleEdit, handleDelete, handleView, handlePrint, handleQc, handleTags });

    /* กางแถวเพื่อดูรายการสินค้าในใบรับ (มาจาก er_grdetail + lot ของแต่ละรายการ) */
    const expandable = {
        expandedRowRender: (record) => (
            <Table
                size='small'
                rowKey='rowkey'
                columns={accessDetailColumn}
                dataSource={record?.detail || []}
                pagination={false}
                scroll={{ x: 'max-content' }}
                style={{ margin: '8px 16px' }}
                locale={{ emptyText: 'ไม่มีรายการสินค้า' }}
            />
        ),
        rowExpandable: (record) => (record?.detail || []).length > 0,
    };

    const getData = (data) => {
        handleSearch()
    }

    const init = async () => {
        getData({});
    }
            
    useEffect( () => {
        const restored = restoreState();

        handleSearch(false, restored?.searchValues ?? null, restored?.tablePagination);

          

        return  async () => { 
            //console.clear();
        }
    }, []);
    const TitleTable = (
        <Flex className='width-100' align='center'>
            <Col span={12} className='p-0'>
                <Flex gap={4} justify='start' align='center'>
                  <Typography.Title className='m-0 !text-zinc-800' level={3}>หน้าจัดการใบรับสินค้า (GoodsReceipt)</Typography.Title>
                </Flex>
            </Col>
            <Col span={12} style={{paddingInline:0}}>
                <Flex gap={4} justify='end'>
                      <Button
                      size='small'
                      className='bn-action bn-center bn-warning-outline justify-center'
                      icon={<PrinterOutlined style={{fontSize:'.9rem'}} />}
                      onClick={() => { handlePrintDaily() } } >
                          Print รายวัน
                      </Button>
                      <Button
                      size='small' 
                      className='bn-action bn-center bn-primary-outline justify-center'  
                      icon={<FileAddOutlined  style={{fontSize:'.9rem'}} />} 
                      onClick={() => { hangleAdd() } } >
                          เพิ่มใบรับสินค้า
                      </Button>
                </Flex>
            </Col>  
        </Flex>
    );    
    return (
    <div className='goodsreceipt-access' id="area">
        <Space direction="vertical" size="middle" style={{ display: 'flex', position: 'relative' }} >
            <Form form={form} layout="vertical" autoComplete="off" onValuesChange={()=>{ handleSearch(true)}}>
                {FormSearch}
            </Form> 
            <Card>
                <Row gutter={[8,8]} className='m-0'>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table 
                        title={()=>TitleTable} 
                        size='small' 
                        rowKey="grcode" 
                        columns={column} 
                        dataSource={accessData} 
                        expandable={expandable}
                        scroll={{ x: 'max-content' }} 
                        pagination={tablePagination}
                        onChange={handleTableChange}
                        />
                    </Col>
                </Row>         
            </Card>
        </Space>
    </div>
    );
}

export default GoodsReceiptAccess;